import React from 'react'
import PropTypes from 'prop-types'
import history from 'utils/getHistory'
import { makeStyles, Card } from '@material-ui/core'
import cn from 'classnames'

import styleHelper from 'utils/styleHelper'
import useMobileDetect from 'hooks/useMobileDetect'

import LoginForm from './LoginForm'
import ForgotPasswordForm from './ForgotPasswordForm'
import UpdatePasswordForm from './UpdatePasswordForm'
import Navbar from './Navbar'

const useStyles = makeStyles(theme => ({
  card: {
    borderRadius: 8,
    boxShadow: '0px 3px 6px rgba(0, 0, 0, 0.1)',
    display: 'flex',
    flexDirection: 'column',
    margin: 'auto',
    padding: '36px 72px',
    maxWidth: 528,
    [styleHelper.tablet]: {
      padding: '36px 60px',
    },
  },
  container: {
    backgroundColor: theme.colors.skyLighter,
    height: '100vh',
    paddingTop: 72,
    paddingBottom: 72,
    [styleHelper.mobile]: {
      backgroundColor: theme.colors.white,
    },
  },
  divider: {
    border: `1px solid ${theme.colors.skyBase}`,
    [styleHelper.mobile]: {
      display: 'none',
    },
  },
  padding: {
    paddingLeft: 240,
    paddingRight: 240,
    [styleHelper.max(1919)]: {
      paddingLeft: 120,
      paddingRight: 120,
    },
    [styleHelper.max(1439)]: {
      paddingLeft: 32,
      paddingRight: 32,
    },
    [styleHelper.max(1023)]: {
      paddingLeft: 30,
      paddingRight: 30,
    },
    [styleHelper.mobile]: {
      paddingLeft: 16,
      paddingRight: 16,
    },
  },
}))

function Login(props) {
  const { page } = props
  const classes = useStyles()
  const isMobile = useMobileDetect().max(768)

  const Form = {
    login: LoginForm,
    forgotPassword: ForgotPasswordForm,
    updatePassword: UpdatePasswordForm,
  }[page] || LoginForm

  return (
    <>
      <div className={classes.padding}>
        <Navbar
          label={page === 'login' ? 'Sign Up' : 'Log in'}
          onClick={() => history.push(page === 'login' ? '/register' : '/login')}
        />
      </div>
      <div className={classes.divider} />
      <div className={cn(classes.container, classes.padding)}>
        {isMobile ? (
          <Form />
        ) : (
          <Card classes={{ root: classes.card }}>
            <Form />
          </Card>
        )}
      </div>
    </>
  )
}

Login.propTypes = {
  page: PropTypes.string.isRequired,
}

export default React.memo(Login)
